export default __webpack_public_path__ + "53fabf6674efb29f7a2597552b02f10d.mp4";